import * as React from 'react'
import { Check, ChevronsUpDown } from 'lucide-react'

import { cn } from '@/lib/utils'
import { Button } from '@/Components/ui/button'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/Components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'
import { Textarea } from '@/Components/ui/textarea'
import { FormControl } from '@/Components/ui/form'
import { Portal } from '@radix-ui/react-portal'

function MultipleSelector({ placeHolder = 'Select', selectedValue = [], onChange, items = [], label, isDuplicateAllow = false, className = '' }) {
    const handleSetValue = (val) => {
        if (!isDuplicateAllow && selectedValue?.includes(val)) {
            return
        }
        console.log("selectedvalue",selectedValue)
        selectedValue?.push(val)
        onChange(selectedValue)
    }
    const handleRemoveValue = (val) => {
        onChange(selectedValue.filter((item) => item !== val))
    }

    return (
        <Popover className="w-full">
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    className={"w-full overflow-hidden h-fit flex flex-wrap gap-1 justify-start " + className}
                >
                    {selectedValue.length > 0 ? (
                        selectedValue.map((val, i) => (
                            <div key={i} className="px-1 rounded-xl border bg-slate-200 text-xs font-medium">
                                <span className="text-wrap cursor-pointer" onClick={() => handleRemoveValue(val, i)}>
                                    {val}
                                </span>
                            </div>
                        ))
                    ) : (
                        <span className="font-normal text-muted-foreground text-gray-300">{placeHolder}</span>
                    )}
                </Button>
            </PopoverTrigger>
            <Portal className='w-full'>
                <PopoverContent className="p-0 z-[9999]" align="start">
                    <Command className="w-full">
                        <CommandInput
                            placeholder={`Search ${placeHolder}`}
                            className="border-none shadow-none focus-visible:ring-0 py-2 px-1 h-fit"
                        />
                        <CommandEmpty>No options found.</CommandEmpty>
                        <CommandGroup className="w-full">
                            <CommandList className="w-full">
                                {items.map((item) => {
                                    return (
                                        <CommandItem
                                            key={item[label]}
                                            value={item[label]}
                                            onSelect={(selectedValue) => {
                                                handleSetValue(selectedValue)
                                            }}
                                        >
                                            {item[label]}
                                        </CommandItem>
                                    )
                                })}
                            </CommandList>
                        </CommandGroup>
                    </Command>
                </PopoverContent>
            </Portal>
        </Popover>
    )
}

export default MultipleSelector
